export { default } from './BorrowingSidebarToggleButton';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/BorrowingSidebarToggleButton/index.js